import useNTGroupAddAthletesFormGrid from './UseNTGroupAddAthletesFormGrid';

import Spinner from '@usas/ui-web/components/spinners/Spinner';
import { SORT_TYPES } from '@usas/ui-web/components/table/utils/TableConstants';
import { Icon, Table, Td, Th, Tr } from '@usas/ui-web/components/table/Table';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import useTableData from '@usas/ui-web/state/table/UseTableData';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import { formatTimeForDisplay } from '@usas/ui-web/utils/TimesUtils';

const NestedTable = ({ data }) => (
  <Table.Nested>
    <thead>
      <tr>
        <th>Event</th>
        <th>Swim Time</th>
        <th>Swim Date</th>
        <th>Meet Name</th>
      </tr>
    </thead>
    <Table.NestedBody data={data} colSpan={4} noDataText='No Events'
      renderRow={(swimEvent, i) =>
        <tr key={i}>
          <td>{swimEvent.eventName || ''}</td>
          <td>{swimEvent.swimTime ? formatTimeForDisplay(swimEvent.swimTime) : ''}</td>
          <td>{swimEvent.swimDate ? formatDate(swimEvent.swimDate) : ''}</td>
          <td>{swimEvent.meetName || ''}</td>
        </tr>
      } />
  </Table.Nested>
);

const TableTopRow = ({ dataTotal, isLoading, onAddClicked }) => {
  const { tableState } = useTableData();

  return (
    <Tr.Top colSpan={4} showDataTotal={isLoading !== true} dataName='Athletes' dataTotal={dataTotal}>
      <ActionIntraPageButton onClick={(e) => onAddClicked(e, tableState.selectedIds)}>Add Selected Athletes {tableState.selectedIds.length > 0 ? `(${tableState.selectedIds.length})` : ''}</ActionIntraPageButton>
    </Tr.Top>
  );
}

const NTGroupAddAthletesFormGrid = ({ gridData, isLoading, onEditClicked, onSubmitFormCallback }) => {
  const {
    formGridState,
    onAddSelectedClicked
  } = useNTGroupAddAthletesFormGrid(gridData, onSubmitFormCallback);


  if (isLoading === true) {
    return <Spinner />;
  }

  return (
    <Table.ContextWrapper data={formGridState} rowIdKey={'personNationalTeamGroupId'} >
      <Table.Large>
        <thead>
          <TableTopRow dataTotal={formGridState.length} isLoading={isLoading} onAddClicked={onAddSelectedClicked} />
          <tr>
            <Th.Input>
              <Icon.SelectAll />
            </Th.Input>
            <Th.Sort sortKey={'lastName'} sortType={SORT_TYPES.ALPHABETICAL}>Name</Th.Sort>
            <Th.Action colSpan={2} style={{ width: '25vw' }}>
              <Icon.ExpandAll />
            </Th.Action>
          </tr>
        </thead>
        <Table.Body colSpan={4} isLoading={isLoading} noDataText='No Group Athletes'
          renderRow={(groupAthlete, i) =>
            <Tr.Accordion key={i} rowId={groupAthlete.personNationalTeamGroupId} tableColSpan={4} nestedTable={<NestedTable data={groupAthlete.events} />}>
              <Td.Input>
                <Icon.Select rowId={groupAthlete.personNationalTeamGroupId} />
              </Td.Input>
              <td style={{ fontWeight: 'bold' }}><a onClick={(e) => onEditClicked(e, groupAthlete)}>{groupAthlete.groupAthleteName || ''}</a></td>
              <Td.Action colSpan={2}>
                <Icon.Expand rowId={groupAthlete.personNationalTeamGroupId} />
              </Td.Action>
            </Tr.Accordion>
          } />
      </Table.Large>
      <Table.Small>
        <thead>
          <TableTopRow dataTotal={formGridState.length} isLoading={isLoading} onAddClicked={onAddSelectedClicked} />
          <tr>
            <Th.Input>
              <Icon.SelectAll />
            </Th.Input>
            <Th.Sort sortKey={'lastName'} sortType={SORT_TYPES.ALPHABETICAL}>Name</Th.Sort>
            <Th.Action colSpan={2} style={{ width: '25vw' }}>
              <Icon.ExpandAll />
            </Th.Action>
          </tr>
        </thead>
        <Table.Body colSpan={4} isLoading={isLoading} noDataText='No Group Athletes'
          renderRow={(groupAthlete, i) =>
            <Tr.Accordion key={i} rowId={groupAthlete.personNationalTeamGroupId} tableColSpan={4} nestedTable={<NestedTable data={groupAthlete.events} />}>
              <Td.Input>
                <Icon.Select rowId={groupAthlete.personNationalTeamGroupId} />
              </Td.Input>
              <td style={{ fontWeight: 'bold' }}><a onClick={(e) => onEditClicked(e, groupAthlete)}>{groupAthlete.groupAthleteName || ''}</a></td>
              <Td.Action colSpan={2}>
                <Icon.Expand rowId={groupAthlete.personNationalTeamGroupId} />
              </Td.Action>
            </Tr.Accordion>
          } />
      </Table.Small>
    </Table.ContextWrapper>
  );
};

export default NTGroupAddAthletesFormGrid;